export const getDapUsers = (state) => state.dap.dapUsers && state.dap.dapUsers.data;

export const getDapUserDetails = (state) =>
	state.dap.dapUserDetails && state.dap.dapUserDetails.data.user;

export const getDapPending = (state) => state.dap.pending;
